module.exports = __webpack_public_path__ + "media/images/icon__socialLink-9f9237eeec8477de533b6a1d7eb1d285.png";